<template lang="pug">
  app-page(title="Документы на подпись" )
    app-toolbar(title="Документы на подпись")

    div
      v-layout(row wrap v-if="docsToSign.length > 0")
        v-flex.px-4(xs4 v-for="(d, index) in preparedDocuments" :key="index"  )
          app-card.document__card(@click.native="selectItem(d)")
            app-card-header
              v-row.flex-nowrap(no-gutters align="baseline")
                .col-auto {{ d.date }} 
                .col-auto.ml-4 {{ d.time }}
                .col.ml-4.text-right(v-line-clamp="1") {{ d.deliveryStatus.title }} ({{ d.sendChannel.title }})
                .ellipse.ml-4(:data-color="d.color")
            app-card-body.document__card-body(v-if="d.sendable!=null && d.sendable.type=='FileRequest'")
              app-card-title.document__card-title {{ d.name }}
              app-card-caption(v-if="d.sendable.organization") Организация:  <b>{{ d.sendable.organization.name }} </b>
              app-card-caption Сторона по делу: <b>{{ d.recipientName }}</b> {{ d.address }}
          
            app-card-body.document__card-body(v-else)
              app-card-title.document__card-title {{ d.name }}
              app-card-caption Получатель: <b>{{ d.recipientName }}</b> {{ d.address }}

    signDoc(v-model="dialogSign" :doc.sync="doc" @sended="sended" @sendfail="showErrorSnack($event)")

    v-snackbar(v-model="errorSnack" color="error" :timeout="6000" vertical top) {{errorSnackText}}
      v-btn(light text @click="errorSnack = false") Закрыть

</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex';
import signDoc from './components/SignDoc'

const colors = ['red', 'yellow', 'green']

export default {
  components: {
    signDoc
  },
  data() {
    return {
      errorSnackText: "Ошибка при подписании",
      errorSnack: false,
      dialogSign: false,
      doc: null
    }
  },

  computed: {
    ...mapGetters('courtCase', ['docsToSign']),

    items () {
      return [{ icon: 'gesture', title: 'Подписать', action: () => this.signDoc() }]
    },

    documentName () {
      return this.doc ? `${ this.doc.name } (${ this.doc.sendChannel.title })` : ''
    },

    preparedDocuments () {
      return this.docsToSign.map(d => {
        d.date = this.date(d)
        d.time = this.time(d)
        d.color = this.statusColor(d)

        if(d.sendable!=null && d.sendable.type=="FileRequest") d.name="Запрос: "+d.name


        let recipient = this.recipient(d)
        d.recipientName = this.recipientName(recipient)

        if(recipient.persona.personaData) {
            let addressItems = recipient.persona.personaData.filter(item => item.dataType.name === 'ADDRESS').sort((a, b) => b.id - a.id)
            let item = addressItems.find(item => item.tag && item.tag.name == 'MAIN') || addressItems[0]
            d.address = item ? item.data : ''
        }

        return d
      })
    },
  },
  methods: {
    showErrorSnack(text) {
      this.errorSnackText = text
      this.errorSnack = true
    },
    sended () {
      let index = this.docsToSign.findIndex(item => item.id === this.doc.id)
      this.docsToSign.splice(index, 1)
    },
    selectItem (item) {
      if (localStorage.getItem("roles").indexOf("JUDGEHELPER") != -1) return false
      this.doc = item
      this.dialogSign = true
    },
    date (d) {
      return moment(d.createDate).format("DD.MM.YYYY")
    },

    time (d) {
      return moment(d.createDate).format("HH:mm")
    },

    statusColor (d) {
      return colors[d.deliveryStatus.color]
    },

    recipient (d) {
      let member = d.sendable.member
      return member ? member : {persona:{address: "Адрес организации", name:"Запрос на организацию", personaType: "UL"}}
    },

    recipientName (member) {
      let { persona } = member
      return (persona.personaType.name == 'UL' && persona.orgName.length > 0) ? persona.orgName : persona.name
    },
  },
  created() {
    this.$store.dispatch('courtCase/LOAD_DOCS_TO_SIGN')
  }
}


</script>

<style lang="scss" scoped>
.ellipse {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-left: 6px;

  &[data-color="red"] {
    background: #ED0E51;
  }
  &[data-color="yellow"] {
    background: #F2BE38;
  }
  &[data-color="green"] {
    background: #2BC113;
  }
}
</style>
